/**
 * Centralized brand constants for the client app.
 *
 * Reads from Vite env vars (VITE_ORDER_PREFIX, VITE_PRODUCT_NAME) with
 * sensible defaults. Every client-side file that needs the order prefix
 * or product name should import from here instead of defining its own
 * fallback — prevents drift and makes white-labeling a single change.
 */

export const ORDER_PREFIX = import.meta.env.VITE_ORDER_PREFIX || 'HLX';
export const PRODUCT_NAME = import.meta.env.VITE_PRODUCT_NAME || 'HemoLogix';
